<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
export default {
	props: {
		jbrxxList: [],
		isOpenType: ''
	},
	data() {
		return {
			headData: getdata().headData,
			tableData: [],
			options: getdata().options,
			zhengjlx: getdata().zhengjlx,
			tablekey: 0,
			DataOverview: {
				UsableLineOfCredit: '',
				OverallLineOfCredit: ''
			},
			disabled: false
		};
	},
	watch: {
		jbrxxList: function(indexVal, oldVal) {
			if (indexVal) {
				this.tableData = indexVal;
			}
		},
		isOpenType: function(indexVal, oldVal) {
			console.log('isOpenType:' + indexVal);
			if (indexVal == '1') {
				this.disabled = true;
			} else {
				this.disabled = false;
			}
		}
	},
	created() {},
	mounted() {
		// this.a();
	},
	methods: {
		// a() {
		// 	this.jibenform=JSON.parse(JSON.stringify(this.checkedRow));
		// 	this.$https.fetchPost('/sys/admin/getCompanyStxx', jibenform.code).then(res => {
		// 		if (res.data.success) {
		// 			this.faplr = JSON.parse(res.data.obj);
		// 			this.faplr.forEach(item => {
		// 				if (item.queskpj == '1') {
		// 					this.faplr.jqbh = item.kaipjbh;
		// 					this.defaultkpj = item.kaipjbh;
		// 					return;
		// 				}
		// 			});
		// 		}
		// 	});
		// },
		Addjbr() {
			this.tableData.push({});
		},
		Deletejbr(e) {
			this.tableData.splice(e, 1);
		},
		RefreshSj() {
			this.DataOverview.UsableLineOfCredit = 10086;
			this.DataOverview.OverallLineOfCredit = 10086;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
